// 子仓库 - FS管理
import to from 'await-to-js';
import * as apis from "@/api/interface/fs";
import * as ctiApis from "@/api/interface/cti";

export default {
  namespaced: true,
  state: () => ({
    // loading: {},
    fsLineConfigList: undefined, //线路配置 - 外呼 - 列表
    fsTaskConfigList: undefined,
    fsDbLineConfigList: undefined, //线路配置 - 点拨 - 列表
    losList: undefined, //线路配置 - 列表
    lcrmsList: undefined, //线路配置 - 列表
    lcdList: undefined, //线路外呼分钟数查询 - 列表
    lccList: undefined, //线路并发配置 - 列表
  }),
  getters: {},
  mutations: {
    // updateLoading(state, payload) {
    //   Object.keys(payload).forEach(key => {
    //     state.loading[key] = payload[key]
    //   });
    //   state.loading = { ...state.loading };
    // },
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
        // state.loading[`${moduleName}/${key}`] = false;
      });
      // state.loading = { ...state.loading };
    },
  },
  actions: {
    // 线路配置 - 外呼 - 组织机构选项列表
    async getFsOrgOptions(ctx, payload = {}) {
      const [, res] = await to(apis.getFsOrgOptions(payload));
      return res;
    },
    // 线路配置 - 外呼 - 线路选项列表
    async getFsLineOptions(ctx, payload = {}) {
      const [, res] = await to(apis.getFsLineOptions(payload));
      return res;
    },
    // 线路配置 - 外呼 - 列表
    async getFsLineConfigList(ctx, payload = {}) {
      // ctx.commit("updateLoading", {[`fs/fsLineConfigList`]: true});
      const [err, res] = await to (apis.getFsLineConfigList(payload));
      ctx.commit("update", {
        fsLineConfigList: !err && res.data ? res.data : undefined,
      });
    },
    async getFsTaskConfigList(ctx, payload = {}) {
      const [err, res] = await to (apis.getFsTaskConfigList(payload));
      ctx.commit("update", {
        fsTaskConfigList: !err && res.data ? res.data : undefined,
      });
    },
    // 线路配置 - 外呼 - 新增 / 保存 / 批量新增
    async fsLineConfigAdd(ctx, payload = {}) {
      const [, res] = await to(apis.fsLineConfigAdd(payload));
      return res;
    },
    async fsTaskUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.fsTaskUpdate(payload));
      return res;
    },
    // 线路配置 - 点拨 - 组织机构选项列表
    async getFsDbOrgOptions(ctx, payload = {}) {
      const [, res] = await to(apis.getFsDbOrgOptions(payload));
      return res;
    },
    // 线路配置 - 点拨 - 列表
    async getFsDbLineConfigList(ctx, payload = {}) {
      // ctx.commit("updateLoading", {[`fs/fsLineConfigList`]: true});
      const [err, res] = await to (apis.getFsDbLineConfigList(payload));
      ctx.commit("update", {
        fsDbLineConfigList: !err && res.data ? res.data : undefined,
      });
    },
    // 线路配置 - 点拨 - 新增 / 保存 / 批量新增
    async fsDbLineConfigAdd(ctx, payload = {}) {
      const [, res] = await to(apis.fsDbLineConfigAdd(payload));
      return res;
    },



    // 线路检测实时报表 - 列表
    async getLosList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLosList(payload));
      ctx.commit("update", {
        losList: !err && res.data ? res.data : undefined,
      });
    },
    // 线路通话对账月报 - 列表
    async getLcrmsList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLcrmsList(payload));
      ctx.commit("update", {
        lcrmsList: !err && res.data ? res.data : undefined,
      });
    },


    // 回拨挂断评分
    async ratingHangupe(_ctx, payload = {}) {
      const [, res] = await to (ctiApis.ratingHangupe(payload));
      return res;
    },



    // 线路外呼分钟数查询 - 列表
    async getLcdList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLcdList(payload));
      ctx.commit("update", {
        lcdList: !err && res.data ? res.data : undefined,
      });
    },
    // 线路外呼分钟数查询 - 导出
    async lcdExport(_, payload = {}) {
      const [, res] = await to(apis.lcdExport(payload));
      return res;
    },



    // 线路外呼分钟数查询 - 列表
    async getLccList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLccList(payload));
      ctx.commit("update", {
        lccList: !err && res.data ? res.data : undefined,
      });
    },
    // 线路并发配置 - 更新
    async lccUpdate(_, payload = {}) {
      const [, res] = await to(apis.lccUpdate(payload));
      return res;
    },
    // 线路并发配置 - 外呼状态摘除/恢复
    async lccToggleState(_, payload = {}) {
      const [err, res] = await to(apis.lccToggleState(payload));
      if (err) throw err;
      return res;
    },



    // 线路分流配置 - 配置
    async getScriptDivideConfig(_ctx, payload = {}) {
      const [, res] = await to (apis.getScriptDivideConfig(payload));
      return res;
    },
    // 线路分流配置 - 剧本选项
    async getScriptOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getScriptOptions(payload));
      return res;
    },
    // 线路分流配置 - 剧本保存
    async scriptDivideSave(_ctx, payload = {}) {
      const [, res] = await to (apis.scriptDivideSave(payload));
      return res;
    },
    // 剧本关联短信 - 短信任务选项
    async getScriptSmsAllocationOptions(_ctx, payload = {}) {
      const [, res] = await to(apis.getScriptSmsAllocationOptions(payload));
      return res;
    },
    // 剧本关联短信 - 配置详情
    async getScriptSmsAllocationConfig(_ctx, payload = {}) {
      const [, res] = await to(apis.getScriptSmsAllocationConfig(payload));
      return res;
    },
    // 剧本关联短信 - 保存配置
    async scriptSmsAllocationSave(_ctx, payload = {}) {
      const [, res] = await to(apis.scriptSmsAllocationSave(payload));
      return res;
    },
    // 零犀短信分流 - 使用中的短信明细
    async getLxSmsDiversionActiveList(_ctx, payload = {}) {
      const [, res] = await to(apis.getLxSmsDiversionActiveList(payload));
      return res;
    },
    // 零犀短信分流 - 配置列表
    async getLxSmsDiversionConfigList(_ctx, payload = {}) {
      const [, res] = await to(apis.getLxSmsDiversionConfigList(payload));
      return res;
    },
    // 零犀短信分流 - 保存配置
    async lxSmsDiversionConfigSave(_ctx, payload = {}) {
      const [, res] = await to(apis.lxSmsDiversionConfigSave(payload));
      return res;
    },

  },
  modules: {},
};
